import selectCollection from "./collection"

export default function selectMeta(state, engine, model, query) {
  const collection = selectCollection(state, engine, model, query)
  if (!collection) {
    return {}
  }

  const { meta } = collection
  if (!meta) {
    return {}
  }

  return meta
}
